import { getNoContentApiClient } from 'adapter/out/client/apiClient';
import DeleteDashboardAnalysisCriteria from 'use-case/analysis/deleteDashboardAnalysis/deleteDashboardAnalysisCriteria';

const deleteDashboardAnalysisApiClient = getNoContentApiClient(
    (criteria: DeleteDashboardAnalysisCriteria) => `dashboards/dashboards/${criteria.dashboardId}/analyses/${criteria.analysisId}`,
    () => ({
        method: 'DELETE',
        body: undefined,
        headers: { 'Content-Type': 'application/json' },
    })
);

export default deleteDashboardAnalysisApiClient;
